import ValidationPack from "../../models/validation-pack.ts";
import ValidationReducerAction from "./validation-reducer-action.ts";

const validationReducer = (draft: ValidationPack[], action: ValidationReducerAction) => {
    switch (action.type) {
        case 'populate': {
            Object.assign(draft, action.payload)
            break;
        }
        case 'updateValidation': {
            const pack = draft.find(p => p.id === action.packId);
            if (pack == null) return;
            pack.updateValidationState(action.state);
            break;
        }
        default:
            break;
    }
}

export default validationReducer;